import ProductTable from "@/components/products/ProductTable";

function ProductsPage() {
    return (
        <div className="w-full">
            <ProductTable />
        </div>
    );
}

export default ProductsPage;
